// extracted by mini-css-extract-plugin
module.exports = {"navbarItem":"navbarmenuitem-module--navbar-item--1um4r","isActive":"navbarmenuitem-module--is-active--1Hd8N"};